package com.kinoshazam.view

import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import com.kinoshazam.uiKit.components.image.ImageUiKitState
import com.kinoshazam.uiKit.components.textField.TextFieldState
import com.kinoshazam.uiKit.components.textLabel.TextLabelState
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.placeholder

object TextFieldPreset {

    fun emailState(
        text: String,
        hint: TextLabelState? = null,
        placeholder: TextLabelState? = null,
        error: TextLabelState? = null,
    ): TextFieldState {
        return TextFieldState(
            textValue = text,
            hint = hint,
            placeholder = placeholder,
            label = error,
            inputType = KeyboardType.Email,
            imeAction = ImeAction.Done,
            isSingleLine = true,
            showError = error != null
        )
    }

    fun passwordState(
        text: String,
        hint: TextLabelState? = null,
        placeholder: TextLabelState? = null,
        error: TextLabelState? = null,
        passwordVisible: Boolean,
    ): TextFieldState {
        return TextFieldState(
            textValue = text,
            hint = hint,
            placeholder = placeholder,
            label = error,
            inputType = KeyboardType.Password,
            imeAction = ImeAction.Done,
            isSingleLine = true,
            showError = error != null,
            visualTransformation = if (passwordVisible) VisualTransformation.None else PasswordVisualTransformation(),
        )
    }

    fun otpState(
        text: String,
        isError: Boolean,
    ): TextFieldState {
        return TextFieldState(
            textValue = text,
            inputType = KeyboardType.NumberPassword,
            isSingleLine = true,
            showError = isError,
            fieldType = TextFieldState.FieldType.Outlined
        )
    }
}